export default "__VITE_ASSET__CX49hLNA__"